import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";

import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AgregarNovedadComponent } from "./ui/components/layouts/forms/agregar-novedad/agregar-novedad.component";
import { SolicitudServicioComponent } from "./ui/components/layouts/forms/solicitud-servicio/solicitud-servicio.component";
import { LoaderComponent } from "./ui/components/layouts/loader/loader.component";
import { NavbarComponent } from "./ui/components/layouts/navbar/navbar.component";
import { AccesoComponent } from "./ui/components/pages/acceso/acceso.component";
import { AjusteSolicitudServiciosComponent } from "./ui/components/pages/ajuste-solicitud-servicios/ajuste-solicitud-servicios.component";
import { AprobacionServicioDirectivoComponent } from "./ui/components/pages/aprobacion-servicio-directivo/aprobacion-servicio-directivo.component";
import { CardDirectivoComponent } from './ui/components/pages/card-directivo/card-directivo.component';
import { CardProgramadorComponent } from './ui/components/pages/card-programador/card-programador.component';
import { CardReferenteComponent } from './ui/components/pages/card-referente/card-referente.component';
import { MsalGuard, MsalInterceptor, MsalModule, MsalRedirectComponent } from "@azure/msal-angular";
import { StoreModule } from "@ngrx/store";
import { environment } from "src/environments/environment";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { InteractionType, PublicClientApplication } from "@azure/msal-browser";
import { API_AZURE_SDS_URL, URL_REDIRECT_AZURE, NgxSdsLoginModule, userReducer, AzureAdService, UserEffects } from "ngx-sds-login";


const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;
import { FooterComponent } from './ui/components/pages/footer/footer.component';
import { GestionSolicitudProgramadorComponent } from "./ui/components/pages/gestion-solicitud-programador/gestion-solicitud-programador.component";
import { PagesSolicitudServicioComponent } from "./ui/components/pages/pages-solicitud-servicio/pages-solicitud-servicio.component";
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { NgbModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { TableOfficialsComponent } from './ui/components/layouts/table-officials/table-officials.component';
import { TableRequestPendingComponent } from './ui/components/layouts/table-request-pending/table-request-pending.component';
import { ValidacionDatosSolicitudServicioComponent } from './ui/components/layouts/forms/validacion-datos-solicitud-servicio/validacion-datos-solicitud-servicio.component';
import { PaginationComponent } from './ui/components/layouts/pagination/pagination.component';
import { CancelarSolicitudServicioComponent } from "./ui/components/layouts/forms/cancelar-solicitud-servicio/cancelar-solicitud-servicio.component";
import { TableConsultRequestComponent } from './ui/components/layouts/table-consult-request/table-consult-request.component';
import { SeguimientoSolicitudesServicioComponent } from "./ui/components/pages/seguimiento-solicitudes-servicio/seguimiento-solicitudes-servicio.component";
import { TableNewsRequestComponent } from './ui/components/layouts/table-news-request/table-news-request.component';
import { BandejaProgramadorComponent } from './ui/components/pages/bandeja-programador/bandeja-programador.component';
import { TableConsultProgrammerComponent } from './ui/components/layouts/table-consult-programmer/table-consult-programmer.component';
import { TableConsultRequestProgrammerComponent } from './ui/components/layouts/table-consult-request-programmer/table-consult-request-programmer.component';
import { GestionVehiculosInternosComponent } from './ui/components/layouts/gestion-vehiculos-internos/gestion-vehiculos-internos.component';
import { GestionVehiculosSubcontratadosComponent } from './ui/components/layouts/forms/gestion-vehiculos-subcontratados/gestion-vehiculos-subcontratados.component';
import { GestionSolicitudTransporteComponent } from './ui/components/pages/gestion-solicitud-transporte/gestion-solicitud-transporte.component';
import { InformesSolicitudesServicioComponent } from './ui/components/pages/informes-solicitudes-servicio/informes-solicitudes-servicio.component';
import { TableRequestReportComponent } from './ui/components/layouts/table-request-report/table-request-report.component';
import { TableSatisfactionSurveyComponent } from './ui/components/layouts/table-satisfaction-survey/table-satisfaction-survey.component';
import { EncuestaSatisfaccionComponent } from './ui/components/pages/encuesta-satisfaccion/encuesta-satisfaccion.component';
import { MenuReferenteComponent } from "./ui/components/pages/menu-referente/menu-referente.component";
import { EffectsModule } from "@ngrx/effects";

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    AccesoComponent,
    MenuReferenteComponent,
    AjusteSolicitudServiciosComponent,
    SolicitudServicioComponent,
    PagesSolicitudServicioComponent,
    GestionSolicitudProgramadorComponent,
    AprobacionServicioDirectivoComponent,
    AgregarNovedadComponent,
    CardDirectivoComponent,
    CardProgramadorComponent,
    CardReferenteComponent,
    LoaderComponent,
    FooterComponent,
    TableOfficialsComponent,
    TableRequestPendingComponent,
    ValidacionDatosSolicitudServicioComponent,
    PaginationComponent,
    CancelarSolicitudServicioComponent,
    SeguimientoSolicitudesServicioComponent,
    TableConsultRequestComponent,
    TableNewsRequestComponent,
    BandejaProgramadorComponent,
    TableConsultProgrammerComponent,
    TableConsultRequestProgrammerComponent,
    GestionVehiculosInternosComponent,
    GestionVehiculosSubcontratadosComponent,
    GestionSolicitudTransporteComponent,
    InformesSolicitudesServicioComponent,
    TableRequestReportComponent,
    TableSatisfactionSurveyComponent,
    EncuestaSatisfaccionComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    NgxSdsLoginModule,
    MsalModule.forRoot(new PublicClientApplication
      (
        {
          auth: {
            clientId: environment.APP_CLIENT_ID,
            authority: environment.APP_AUTHORITY,
            redirectUri: environment.APP_REDIRECT_TO,
            knownAuthorities: [environment.APP_AUTHORITY],
          },

          cache: {
            cacheLocation: "localStorage",
            storeAuthStateInCookie: isIE
          }
        }
      ),
      {
        interactionType: isIE ? InteractionType.Redirect : InteractionType.Popup,
        authRequest: {
          scopes: [`https://saludcapitalb2c.onmicrosoft.com/${environment.APP_CLIENT_ID}/${environment.APP_ROL_URL}`] 
        }
      },
      {
        interactionType: isIE ? InteractionType.Redirect : InteractionType.Popup,
        protectedResourceMap: new Map(
          [
            ['https://graph.microsoft.com/v1.0/me', [environment.APP_ROL_URL]]
          ]
        ) 
      }      
    ),
    StoreModule.forRoot({
      user: userReducer
    }), 
    !environment.production ? StoreDevtoolsModule.instrument() : [],              
    LoadingBarModule,
    LoadingBarHttpClientModule,
    NgbModule,
    NgbPaginationModule,
    EffectsModule.forRoot([])
  ],
  exports: [
    AppComponent,
    NavbarComponent,
    AccesoComponent,
    MenuReferenteComponent,
    AjusteSolicitudServiciosComponent,
    SolicitudServicioComponent,
    PagesSolicitudServicioComponent,
    GestionSolicitudProgramadorComponent,
    AprobacionServicioDirectivoComponent,
    AgregarNovedadComponent,
    CardDirectivoComponent,
    CardProgramadorComponent,
    CardReferenteComponent,
    LoaderComponent,
    ValidacionDatosSolicitudServicioComponent,
    PaginationComponent,
    CancelarSolicitudServicioComponent,
    TableConsultRequestComponent,
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: API_AZURE_SDS_URL, useValue: environment.baseUrl},
    { provide: URL_REDIRECT_AZURE, useValue: environment.postLogoutUrl },         
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    MsalGuard,
    AzureAdService,     
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule { }
